import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "items-container" }
const _hoisted_2 = { class: "items-scroll" }
const _hoisted_3 = { class: "items-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_Item, {
            key: item.id,
            id: item.id,
            icon: item.item.icon,
            type: item.item.type,
            name: item.item.name,
            price: item.item.priceUsd,
            color: item.item.color,
            volume: (item.buyPriceUsd && item.item.priceUsd && item.item.priceUsd > item.buyPriceUsd) ? 0 : (item.item.marketVolume || 0),
            exterior: item.item.exterior,
            stattrak: item.item.stattrak,
            active: _ctx.selectedItems.includes(item.id),
            imageSize: _ctx.imageSize,
            gamesCount: item.gamesCount,
            totalGamesCount: item.totalGamesCount,
            onClick: ($event: any) => (_ctx.select(item))
          }, null, 8, ["id", "icon", "type", "name", "price", "color", "volume", "exterior", "stattrak", "active", "imageSize", "gamesCount", "totalGamesCount", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}